import { useState } from "react";
import { useSnackbar } from "notistack";

import { IAuthService } from "../../../../modules/user/models/IAuthService";
import { useIocContext } from "../../../../contexts/ioc/IocContext";
import { Types } from "../../../../ioc/types";
import { useQueryParams } from "../../../../hooks/ContextualNavigations";
import { getSnackbar } from "../../../../utils/Snackbars";
import AppError from "../../../../utils/appError";

// Lógica única de envio do "esqueci a senha", extraída das views Desktop e Mobile (que a
// duplicavam). Monta o metadata igual ao fluxo atual (payload ? {payload} : {url,rules,path}),
// chama forgetPassword e trata sucesso/erro por snackbar. O que fazer no sucesso (inline vs
// navegar para /confirm-email) é decidido pelo chamador via onSuccess.
export function useForgotPasswordSubmit() {
  const iocContext = useIocContext();
  const authService = iocContext.serviceContainer.get<IAuthService>(Types.User.IAuthService);
  const { queryDict } = useQueryParams();
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (email: string, onSuccess: () => void): Promise<void> => {
    setIsSubmitting(true);
    try {
      const { payload, url, rules, path } = queryDict as Record<string, string | undefined>;
      const metadata = payload ? { payload } : { url, rules, path };

      await authService.forgetPassword({ email, metadata });

      enqueueSnackbar(
        getSnackbar({ message: "Email Enviado com sucesso", variant: "success" })
      );
      onSuccess();
    } catch (error) {
      if (error instanceof AppError) {
        enqueueSnackbar(getSnackbar({ message: error.message, variant: error.variant }));
      } else {
        enqueueSnackbar(
          getSnackbar({
            message: "Não foi possível enviar o email, tente novamente.",
            variant: "error",
          })
        );
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return { submit, isSubmitting };
}
